import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-table-cloneable', 'addRow', 'Add row');
Labels.set('ui-table-cloneable', 'removeRow', 'Remove row');
